import { styled, Typography } from '@mui/material';
import { theme } from 'assets/themes/zizzi';
import ArrowForwardIosSharpIcon from '@mui/icons-material/ArrowForwardIosSharp';

export const Arrow = styled(ArrowForwardIosSharpIcon)`
  color: ${theme.palette.primary.main};
  font-size: 1.1rem;
  transform: rotate(90deg);
`;

export const Title = styled(Typography)`
  font-weight: bold;
`;
